import { useEffect, useState } from "react";

/**
 * Five static routes and no nesting, so a full router would be more moving
 * parts than the app has pages.
 */
export function useRoute(): string {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const sync = () => setPath(window.location.pathname);
    window.addEventListener("popstate", sync);
    window.addEventListener("saucer:navigate", sync);
    return () => {
      window.removeEventListener("popstate", sync);
      window.removeEventListener("saucer:navigate", sync);
    };
  }, []);

  return path;
}

export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new Event("saucer:navigate"));
}
